export const URLs = {
  //CheckIn
  CHECKIN_STATUS: (storeID: string) => `/stores/${storeID}/checkin-status`,
  CHECKIN: (storeID: string) => `/stores/${storeID}/checkin`,
  CHECKOUT: (storeID: string) => `/stores/${storeID}/checkout`,
  checkIn: {
    create: (storeID: string, employeeID: string) =>
      `/stores/${storeID}/employees/${employeeID}/checkins`,
  },
  //Dashboard
  Dashboard: {
    totalBilled: (orgID: string) => `/orgs/${orgID}/dashboards/total-billed`,
    totalBookings: (orgID: string) => `/orgs/${orgID}/dashboards/total-bookings`,
    totalEmployees: (orgID: string) => `/orgs/${orgID}/dashboards/total-employees`,
    totalServices: (orgID: string) => `/orgs/${orgID}/dashboards/total-services`,
    productInventory: (orgID: string, query: string) =>
      `/orgs/${orgID}/dashboards/inventory-status${query}`,
    checkinCars: (orgID: string, query: string) => `/orgs/${orgID}/dashboards/checkin-cars${query}`,
    commingRevenue: (orgID: string, query: string) =>
      `/orgs/${orgID}/dashboards/comming-revenue${query}`,
    percentNewCustomers: (orgID: string, query: string) =>
      `/orgs/${orgID}/dashboards/percent-new-customers${query}`,
    todaysRevenue: (orgID: string, query: string) =>
      `/orgs/${orgID}/dashboards/todays-revenue${query}`,
    widgetSelections: (orgID: string) => `/orgs/${orgID}/dashboard-widget-selections`,
    userWidgetSelections: (orgID: string, userID: string) =>
      `/orgs/${orgID}/users/${userID}/dashboard-widget-selections`,
  },

  //Auth
  LOGIN: '/login',
  LOGOUT: '/logout',
  REFRESH_TOKEN: '/refresh-token',

  //Rent Car
  RentCar: {
    availableRentCars: (storeID: string, query: string) =>
      `/stores/${storeID}/available-rentCars${query}`,
    create: (storeID: string) => `/stores/${storeID}/rent-cars`,
    byRegNum: (storeID: string, regNum: string) => `/stores/${storeID}/rent-cars/${regNum}`,
    list: (storeID: string, query: string) => `/stores/${storeID}/rent-cars${query}`,
    listHistory: (storeID: string, query: string) =>
      `/stores/${storeID}/rent-car-booking-history${query}`,
  },
  RENT_CAR: (storeID: string, query: string) => `/stores/${storeID}/rent-cars${query}`,

  //Org
  Org: {
    // Basic org profile (name/address/contact) readable by any org member — not the
    // platform-admin-only `/orgs/:orgID` endpoint used by the admin panel.
    profile: (orgID: string) => `/orgs/${orgID}/profile`,
  },

  //Stores
  STORES: (orgID: string) => `/orgs/${orgID}/stores`,

  Bills: {
    list: (storeID: string, query: string) => `/stores/${storeID}/bills${query}`,
    create: (orgID: string, storeID: string) => `/orgs/${orgID}/stores/${storeID}/bills`,
    getByID: (storeID: string, billID: string) => `/stores/${storeID}/bills/${billID}`,
    byID: (orgID: string, storeID: string, billID: string) =>
      `/orgs/${orgID}/stores/${storeID}/bills/${billID}`,
  },
  Bookings: {
    create: (orgID: string, storeID: string) => `/orgs/${orgID}/stores/${storeID}/orders`,
    list: (orgID: string, storeID: string, query: string) =>
      `/orgs/${orgID}/stores/${storeID}/orders${query}`,
    byID: (orgID: string, query: string) => `/orgs/${orgID}/orders${query}`,
    update: (orgID: string, storeID: string, orderID: string) =>
      `/orgs/${orgID}/stores/${storeID}/orders/${orderID}`,
    delete: (orgID: string, orderID: string) => `/orgs/${orgID}/orders/${orderID}`,
    kanban: (storeID: string, query: string) => `/stores/${storeID}/kanban${query}`,
    updateBoard: (storeID: string, orderID: string) =>
      `/stores/${storeID}/orders/${orderID}/update-board`,
    orderList: (orgID: string, storeID: string) => `/orgs/${orgID}/stores/${storeID}/order-list`,
  },
  DailyNotes: {
    put: (storeID: string) => `/stores/${storeID}/daily-notes`,
    list: (storeID: string, query: string) => `/stores/${storeID}/daily-notes${query}`,
  },
  Category: {
    byIDService: (orgID: string, serviceCategoryID: string) =>
      `/orgs/${orgID}/service-categories/${serviceCategoryID}`,
    byIDProduct: (orgID: string, productCategoryID: string) =>
      `/orgs/${orgID}/product-categories/${productCategoryID}`,
    createService: (orgID: string) => `/orgs/${orgID}/service-categories`,
    createProduct: (orgID: string) => `/orgs/${orgID}/product-categories`,
    listProduct: (orgID: string, query: string) => `/orgs/${orgID}/products-categories${query}`,
    listService: (orgID: string, query: string) => `/orgs/${orgID}/service-categories${query}`,
  },
  Companies: {
    byID: (orgID: string, companyOrgNumber: string) =>
      `/orgs/${orgID}/company-org-numbers/${companyOrgNumber}`,
    create: (orgID: string) => `/orgs/${orgID}/companies`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/companies${query}`,
  },
  Customers: {
    byID: (orgID: string, driverID: string) => `/orgs/${orgID}/drivers/${driverID}`,
    create: (orgID: string) => `/orgs/${orgID}/drivers`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/drivers${query}`,
  },
  EmailTemplates: {
    byID: (orgID: string, emailTemplateID: string) =>
      `/orgs/${orgID}/email-templates/${emailTemplateID}`,
    create: (orgID: string) => `/orgs/${orgID}/email-templates`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/email-templates${query}`,
  },
  Employees: {
    byID: (orgID: string, employeeID: string) => `/orgs/${orgID}/employees/${employeeID}`,
    byUserID: (orgID: string, userID: string) => `/orgs/${orgID}/users/${userID}/employees`,
    create: (orgID: string) => `/orgs/${orgID}/employees`,
    list: (storeID: string, query: string) => `/stores/${storeID}/employees${query}`,
  },
  Permissions: {
    create: () => `/permissions`,
    getByID: (orgID: string, permissionID: string) => `/orgs/${orgID}/permissions/${permissionID}`,
    byID: (permissionID: string) => `/permissions/${permissionID}`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/permissions${query}`,
  },
  Products: {
    byID: (storeID: string, productID: string) => `/stores/${storeID}/products/${productID}`,
    create: (orgID: string) => `/orgs/${orgID}/products`,
    delete: (orgID: string, productID: string, type: string) =>
      `/orgs/${orgID}/products/${productID}/type/${type}`,
    list: (orgID: string, storeID: string, query: string) =>
      `/orgs/${orgID}/stores/${storeID}/products${query}`,
    update: (orgID: string, productID: string, type: string) =>
      `/orgs/${orgID}/type/${type}/products/${productID}`,
  },
  Qualifications: {
    byIDGlobal: (orgID: string, globalQualID: string) =>
      `/orgs/${orgID}/global-qualifications/${globalQualID}`,
    byIDLocal: (storeID: string, localQualID: string) =>
      `/stores/${storeID}/local-qualifications/${localQualID}`,
    createGlobal: (orgID: string) => `/orgs/${orgID}/global-qualifications`,
    createLocal: (storeID: string) => `/stores/${storeID}/local-qualifications`,
    deleteGlobal: (orgID: string) => `/orgs/${orgID}/global-qualifications`,
    deleteLocal: (storeID: string) => `/stores/${storeID}/local-qualifications`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/qualifications-list${query}`,
  },
  Users: {
    create: (orgID: string) => `/orgs/${orgID}/users`,
    createWithEmployee: (orgID: string) => `/orgs/${orgID}/users/employees`,
    byID: (orgID: string, userID: string) => `/orgs/${orgID}/users/${userID}`,
    update: (userID: string) => `/users/${userID}`,
    changePassword: (userID: string) => `/users/${userID}/update-password`,
    loginHistory: (orgID: string, userID: string) => `/orgs/${orgID}/users/${userID}/login-history`,
  },
  Roles: {
    create: (orgID: string) => `/orgs/${orgID}/roles`,
    byID: (orgID: string, roleID: string) => `/orgs/${orgID}/roles/${roleID}`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/roles${query}`,
    // GET only — returns a role's full permission set with assigned/unassigned status.
    roleWithPermissions: (orgID: string, roleID: string) =>
      `/orgs/${orgID}/roles/${roleID}/role_with_permissions`,
    // POST — bulk-assigns permissions to role(s) via body { rtps: [{ roleID, permissionID }] }.
    roleToPermissions: (orgID: string) => `/orgs/${orgID}/role-to-permissions`,
    // DELETE — unassigns a single permission from a role.
    roleToPermission: (orgID: string, roleID: string, permissionID: string) =>
      `/orgs/${orgID}/roles/${roleID}/permissions/${permissionID}`,
  },
  Services: {
    byID: (orgID: string, type: string = 'Local', serviceID: string) =>
      `/orgs/${orgID}/types/${type}/services/${serviceID}`,
    create: (orgID: string, type?: string) => `/orgs/${orgID}/types/${type}/services`,
    list: (orgID: string, storeID: string, query: string) =>
      `/orgs/${orgID}/stores/${storeID}/services${query}`,
    createVariant: (orgID: string, storeID: string, serviceID: string) =>
      `/orgs/${orgID}/stores/${storeID}/services/${serviceID}/service-variant`,
    byIDVariant: (orgID: string, storeID: string, serviceID: string, serviceVariantID: string) =>
      `/orgs/${orgID}/stores/${storeID}/services/${serviceID}/service-variant${serviceVariantID}`,
  },
  SMSTemplates: {
    byID: (orgID: string, smsTemplateID: string) => `/orgs/${orgID}/sms-templates/${smsTemplateID}`,
    create: (orgID: string) => `/orgs/${orgID}/sms-templates`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/sms-templates${query}`,
  },
  Stores: {
    create: (orgID: string) => `/orgs/${orgID}/stores`,
    byID: (orgID: string, storeID: string) => `/orgs/${orgID}/stores/${storeID}`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/stores${query}`,
  },
  Vehicles: {
    byID: (orgID: string, driverCarID: string) => `/orgs/${orgID}/driver-cars/${driverCarID}`,
    byRegNumber: (orgID: string, driverCarRegistrationNumber: string) =>
      `/orgs/${orgID}/driver-car-regs/${driverCarRegistrationNumber}`,
    create: (orgID: string) => `/orgs/${orgID}/driver-cars`,
    delete: (orgID: string, driverCarID: string) => `/orgs/${orgID}/drivers-cars/${driverCarID}`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/driver-cars${query}`,
    vehicleCustomerMap: (orgID: string, driverID: string) => `/orgs/${orgID}/driverIDs/${driverID}`,
  },
  Uploads: {
    create: (orgID: string) => `/orgs/${orgID}/uploads`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/uploads${query}`,
    byID: (orgID: string, uploadID: string) => `/orgs/${orgID}/uploads/${uploadID}`,
    profilePic: (orgID: string, uploadID: string) =>
      `/orgs/${orgID}/uploads/${uploadID}/profile-pic`,
  },
  PackageDeals: {
    list: (orgID: string, storeID: string, query: string) =>
      `/orgs/${orgID}/stores/${storeID}/packageDeals${query}`,
    byID: (orgID: string, storeID: string, packageID: string) =>
      `/orgs/${orgID}/stores/${storeID}/packageDeals/${packageID}`,
    create: (orgID: string, storeID: string) => `/orgs/${orgID}/stores/${storeID}/packageDeals`,
  },
  UnionAgreements: {
    create: (orgID: string) => `/orgs/${orgID}/union-agreements`,
    byID: (orgID: string, id: string) => `/orgs/${orgID}/union-agreements/${id}`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/union-agreements${query}`,
  },
  Leaves: {
    create: (employeeID: string, storeID: string) =>
      `/employees/${employeeID}/stores/${storeID}/leaves`,
    delete: (employeeID: string, storeID: string) =>
      `/employees/${employeeID}/stores/${storeID}/leaves`,
    getByRange: (employeeID: string, storeID: string, leaveStart: string, leaveEnd: string) =>
      `/employees/${employeeID}/stores/${storeID}/leave-starts/${leaveStart}/leave-ends/${leaveEnd}/leaves`,
    list: (storeID: string) => `/stores/${storeID}/leaves`,
  },
  WeeklyNotes: {
    getWeeklyNotes: (storeID: string, week: string) => `/stores/${storeID}/week-notes/${week}`,
    put: (storeID: string) => `/stores/${storeID}/week-notes`,
  },
  WorkingHours: {
    openingHours: (storeID: string) => `/stores/${storeID}/store-opening-hours`,
    specialOpeningHours: (storeID: string) => `/stores/${storeID}/store-special-opening-hours`,
  },
  Timesheets: {
    create: (orgID: string) => `/orgs/${orgID}/timesheets`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/timesheets${query}`,
    byID: (orgID: string, timesheetID: string) => `/orgs/${orgID}/timesheets/${timesheetID}`,
    full: (orgID: string, timesheetID: string) => `/orgs/${orgID}/timesheets/${timesheetID}/full`,
  },
  TimesheetEntries: {
    create: (orgID: string) => `/orgs/${orgID}/timesheet-entries`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/timesheet-entries${query}`,
    byID: (orgID: string, timesheetEntryID: string) =>
      `/orgs/${orgID}/timesheet-entries/${timesheetEntryID}`,
  },
  TimesheetApprovals: {
    create: (orgID: string) => `/orgs/${orgID}/timesheet-approvals`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/timesheet-approvals${query}`,
    byID: (orgID: string, timesheetApprovalID: string) =>
      `/orgs/${orgID}/timesheet-approvals/${timesheetApprovalID}`,
  },
  TimesheetComments: {
    create: (orgID: string) => `/orgs/${orgID}/timesheet-comments`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/timesheet-comments${query}`,
    byID: (orgID: string, timesheetCommentID: string) =>
      `/orgs/${orgID}/timesheet-comments/${timesheetCommentID}`,
  },
  Statistics: {
    services: (orgID: string, query: string) => `/orgs/${orgID}/statistics/services${query}`,
    products: (orgID: string, query: string) => `/orgs/${orgID}/statistics/products${query}`,
    checkins: (storeID: string, query: string) => `/stores/${storeID}/statistics/checkins${query}`,
    revenue: (orgID: string, query: string) => `/orgs/${orgID}/statistics/revenue${query}`,
  },
  AbsenceTypes: {
    create: (orgID: string) => `/orgs/${orgID}/absence-types`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/absence-types${query}`,
    byID: (orgID: string, absenceTypeID: string) => `/orgs/${orgID}/absence-types/${absenceTypeID}`,
  },
  Absences: {
    create: (orgID: string, employeeID: string) =>
      `/orgs/${orgID}/employees/${employeeID}/absences`,
    getByID: (orgID: string, employeeID: string, absenceID: string) =>
      `/orgs/${orgID}/employees/${employeeID}/absences/${absenceID}`,
    update: (orgID: string, employeeID: string, absenceID: string) =>
      `/orgs/${orgID}/employees/${employeeID}/absences/${absenceID}`,
    delete: (orgID: string, absenceID: string) => `/orgs/${orgID}/absences/${absenceID}`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/absences${query}`,
    listAll: (orgID: string, query: string) => `/orgs/${orgID}/absences${query}`,
  },
  OrderListingStatuses: {
    list: (orgID: string, storeID: string) =>
      `/orgs/${orgID}/stores/${storeID}/order-listing-statuses`,
    listPaginated: (orgID: string, storeID: string) =>
      `/orgs/${orgID}/stores/${storeID}/order-listing-statuses/paginated`,
    byID: (orgID: string, storeID: string, orderListingStatusID: string) =>
      `/orgs/${orgID}/stores/${storeID}/order-listing-statuses/${orderListingStatusID}`,
  },
  Overtimes: {
    create: (employeeID: string, storeID: string) =>
      `/employees/${employeeID}/stores/${storeID}/overtimes`,
    listByStore: (storeID: string, query: string) => `/stores/${storeID}/overtime${query}`,
    listByEmployee: (employeeID: string, storeID: string, query: string) =>
      `/employees/${employeeID}/stores/${storeID}/overtimes${query}`,
  },
}
